// extracted by mini-css-extract-plugin
export default {"container":"RIEOYs","item":"LHVgqZ"};